/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFormatShapes = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 2v2h8V2h6v6h-2v8h2v6h-6v-2H8v2H2v-6h2V8H2V2zM6 18H4v2h2zm14 0h-2v2h2zM16 6H8v2H6v8h2v2h8v-2h2V8h-2zm-3.333 2L16 15h-1.333l-.858-1.8H10.19L9.333 15H8l3.333-7zM12 9.4 10.762 12h2.476zM6 4H4v2h2zm14 0h-2v2h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgFormatShapes as FormatShapes };
